import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './toast.scss';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const Toast = ({ message, visible, onHide }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onHide();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible, onHide]);

  if (!visible) return null;

  return createPortal(
    <div className="toastContainer">
      <div className="toastContent">
        <CheckCircleOutlineIcon className="toastIcon" />
        <span>{message}</span>
      </div>
    </div>,
    document.body
  );
};

export default Toast;
